import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type EmptyStatePurpose =
  | 'no-results'
  | 'no-records'
  | 'no-live-matches'
  | 'no-matches-scheduled'
  | 'no-tournaments'
  | 'no-participants';

interface EmptyStateContent {
  titleKey: string;
  descriptionKey: string;
}

const EMPTY_STATE_CONTENT: Record<EmptyStatePurpose, EmptyStateContent> = {
  'no-results': { titleKey: 'empty_state_no_results_title', descriptionKey: 'empty_state_no_results_desc' },
  'no-records': { titleKey: 'empty_state_no_records_title', descriptionKey: 'empty_state_no_records_desc' },
  'no-live-matches': { titleKey: 'empty_state_no_live_matches_title', descriptionKey: 'empty_state_no_live_matches_desc' },
  'no-matches-scheduled': { titleKey: 'empty_state_no_matches_scheduled_title', descriptionKey: 'empty_state_no_matches_scheduled_desc' },
  'no-tournaments': { titleKey: 'empty_state_no_tournaments_title', descriptionKey: 'empty_state_no_tournaments_desc' },
  'no-participants': { titleKey: 'empty_state_no_participants_title', descriptionKey: 'empty_state_no_participants_desc' }
};

/**
 * Shared empty-state card. Pass a `purpose` and it renders the matching
 * icon + default copy; `title`/`description` override the copy when a
 * parent needs context-specific text (e.g. an active filter name).
 */
@Component({
  selector: 'stupa-empty-state',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyStateComponent {
  purpose = input.required<EmptyStatePurpose>();
  title = input<string>();
  description = input<string>();

  protected readonly titleKey = computed(() => EMPTY_STATE_CONTENT[this.purpose()].titleKey);
  protected readonly descriptionKey = computed(() => EMPTY_STATE_CONTENT[this.purpose()].descriptionKey);
}
